import React, { useState, useEffect } from "react"

import { StaticImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

import * as styles from "./subscribe-home.module.scss"
import Wrapper from "../../atoms/wrapper"
import FormState from "../../molecules/form-state"
import SubscribeFirst from "../../molecules/subscribe-first"
import SubscribeSecond from "../../molecules/subscribe-second"
import SubscribeThird from "../../molecules/subsribe-third"

const SubscribeHome = ({ data, home }) => {
  const [step, setStep] = useState("first")
  const [email, setEmail] = useState("")
  const vertical = data.sanitySubscribe.vertical.slug.current.replace("-", "")

  useEffect(() => {
    if (sessionStorage.getItem(`subscribed_${vertical}`)) setStep("third")
  }, [])

  return (
    <Wrapper className={styles.wrapper}>
      <div
        id="subscribe"
        className={`${styles.subscribe} ${
          home ? styles.subscribe__home : styles[`subscribe__${vertical}`]
        }`}
      >
        <div className={styles.left}>
          <FormState condition={step === "first"}>
            <GoogleReCaptchaProvider
              reCaptchaKey={process.env.GATSBY_RECAPTCHA_KEY}
            >
              <SubscribeFirst
                data={data.sanitySubscribe}
                changeStep={setStep}
                changeEmail={setEmail}
                home
                light={!home}
              />
            </GoogleReCaptchaProvider>
          </FormState>
          <FormState condition={step === "second"}>
            <SubscribeSecond
              data={data.sanitySubscribe}
              changeStep={setStep}
              email={email}
              home
              light={!home}
            />
          </FormState>
          <FormState flex condition={step === "third"}>
            <SubscribeThird
              data={data.sanitySubscribe}
              email={email}
              home
              bg={
                home
                  ? "sky"
                  : data.sanitySubscribe.vertical.color?.replaceAll("-", "")
              }
            />
          </FormState>
        </div>
        <div className={styles.right}>
          <StaticImage
            className={styles.image}
            src="../../../images/scenes/iphone_newsletter.jpg"
            alt=""
          />
        </div>
      </div>
    </Wrapper>
  )
}

SubscribeHome.propTypes = {
  data: PropTypes.object.isRequired,
  home: PropTypes.bool,
}

SubscribeHome.defaultProps = {
  home: false,
}

export default SubscribeHome
